module.exports = __webpack_public_path__ + "images/creditplus-76e1420c.png";